import { ELanguage, EPages } from '@microfrontends/app-shell-v2'
import MainLayout from '../../containers/MainLayout'
import SalaryGrossNet from '../../containers/SalaryGrossNet'

import {
	getServerSideProps,
	ISalaryConverterPageProps
} from '../../ssr/salaryConverter'

import { withTranslation } from '../../i18n'
import { convertMetaInfo } from '../../util/convertMetaInfo'

export function Salary(props: ISalaryConverterPageProps) {
	const {
		title: metaTitle,
		description: metaDescription,
		canonicalUrl: metaCanonicalUrl
	} = props.metaData || {}
	return (
		<MainLayout
			{...props}
			metaCanonical={metaCanonicalUrl || 'tinh-luong-gross-net'}
			pageName={EPages.SALARY_CONVERTER}
			languageCode={ELanguage.VI}
			metaTitle={
				convertMetaInfo(metaTitle) ||
				'Công cụ tính lương Gross - Net chuẩn nhất 2023 | VietnamWorks'
			}
			metaDescription={
				convertMetaInfo(metaDescription) ||
				'Công cụ tính lương và chuyển đổi lương từ Gross sang Net và ngược lại nhanh nhất. Cập nhật thông tin về cách tính lương theo quy định Nhà nước mới nhất tại VietnamWorks!'
			}
		>
			<SalaryGrossNet
				language={ELanguage.VI}
				ssrRecommendJobs={props.ssrRecommendJobs}
			/>
		</MainLayout>
	)
}

export default withTranslation('home')(Salary as any)

export { getServerSideProps }
